<template>
<div class="invite">
  <div class="bannerInfo">
    <div class="header">
      <span class="imageBlock"><img class="return_ico" @click="goIndex()" src="@/assets/images/header/return.png"/></span>
      <span class="title">{{type == 1 ? '邀请车主' : '邀请租客'}}</span>
      <span @click="goRule()">邀请规则</span>
    </div>
    <div class="titleBg">{{type == 1 ? '邀请车主 一起赚钱' : '开启全新有车生活方式'}}</div>
  </div>
  <div class="inviteBlock">
    <div class="rewardCon">
      <div class="top">
        <div class="item">
          <span class="value">{{inviteInfo.count}}</span>
          <span>已邀请人数</span>
        </div>
        <div class="line"></div>
        <div class="item">
          <span class="value">{{inviteInfo.bonus}}.00</span>
          <span>奖励（元）</span>
        </div>
      </div>
      <div class="inviteBtn" @click="openShare()">立即邀请 {{type == 1 ? '赚提成' : '得返现'}}</div>
    </div>
    <div class="recordCon">
      <div class="navs">
        <div class="navtab" v-for="(vo,index) in navData" :key="index">
          <div :class="[curNav == vo.value ? 'on':'','nav']" @click="setNav(vo.value)">
            {{vo.key}}
          </div>
        </div>
      </div>
        <div class="content">
          <scroll class="list" :data="inviteList" :pulldown="true" @onPullDownRefresh="onPullDownRefresh" :pullup="true" @onPullUp="lower">
            <div>
              <div class="item" v-for="(item,index) in inviteList" :key="index">
                <div class="left">
                  <span class="name">{{curNav == 0 ? item.Telephone : item.Name}}</span>
                  <span>{{item.RegisterTime}}</span>
                </div>
                <div :class="['right',curNav == 1 ? 'amount' : '']">{{curNav == 0 ? item.StatusText : item.Amount+'元'}}</div>
              </div>
              <div class="nodata" v-if="inviteList.length ==0">
                <img src="@/assets/images/invite/nodata.png"/>
                <span>空空如也~</span>
              </div>
              <div class="end" v-else>{{curNav == 0 ? '再接再厉 继续邀请吧~' : '没有更多啦~'}}</div>
            </div>
          </scroll>
        </div>
    </div>

  </div>
  <div class="share" v-if="showShare">
    <div class="mask" @click="closeShare()"></div>
    <div class="content">
      <div class="title">邀请方式</div>
      <div class="bar">
      <div class="item" v-if="deviceType==3" @click="shareWechat">
        <img class="ico" src="@/assets/images/invite/share1.png"/>
        <div class="txt">微信好友</div>
        <button class="btn" type="default" open-type="share"></button>
      </div>
      <div class="item"  v-clipboard:copy="configureInfo.href" v-clipboard:success="onCopy">
        <img class="ico" src="@/assets/images/invite/share2.png"/>
        <div class="txt">链接邀请</div>
      </div>
    </div>
    </div>
  </div>
</div>
</template>

<script>
  import {resourceUrl,deviceType,sweixin} from '@/utils/env'
  import {inviteOwnersInfo,inviteMemberRecords,inviteBonusRecords,getCurrentMemberInfo} from "@/utils/api";
  import scroll from "@/components/scroll.vue";
    export default {
      name: "invite",
      data: function () {
        return {
          curNav: 0, //当前导航 0.邀请记录 1奖励记录
          type:1, //1.邀请车主 2.邀请租客
          pageindex: 1,
          total_page:0,
          showShare:false,
          url:'',
          resourceUrl: resourceUrl,
          deviceType: deviceType,
          navData: [
            {
              key: "邀请记录",
              value: 0
            },
            {
              key: "奖励记录",
              value: 1
            }
          ],
          inviteInfo: {
            bonus:0,
            count:0
          },
          memberInfo:{},
          configureInfo:{
            title:'',
            href:'',
            thumbs:'',
            content:''
          },
          inviteList:[]
        }
      },
      components: {
        scroll
      },
      created() {
        this.type = this.$route.query.type || 1;
      },
      mounted() {
        this.initInviteInfo();
        this.inviteMember();
        this.getUserInfo();
      },
      methods: {
        async getUserInfo(){
          let res = await getCurrentMemberInfo();
          if(res.Code == 100){
            this.memberInfo = res.Data;
            let name = '';
            if(this.memberInfo.Name){
              name = '*' + this.memberInfo.Name.slice(1);
            }else{
              name = this.memberInfo.Telephone;
            }
            if(this.type == 1){
              this.configureInfo.thumbs = ['http://cms.dafang24.com/CarOwnerInvite/images/Owner.jpg'];
              this.configureInfo.href = 'http://cms.dafang24.com/CarOwnerInvite/pages/InviteOwners.html?name=' + encodeURIComponent(name)+ '&userID=' + this.memberInfo.UserID;
              this.configureInfo.title = '大方共享——大方租车旗下有专业门店服务的私家车共享平台';
              this.configureInfo.content = '我正在大方共享平台挂靠爱车赚收益，赶快加入跟我一起躺着赚钱吧！';
            }else{
              this.configureInfo.thumbs = ['http://cms.dafang24.com/CarOwnerInvite/images/Tenants.jpg'];
              this.configureInfo.href = 'http://cms.dafang24.com/CarOwnerInvite/pages/InviteTenants.html?name=' + encodeURIComponent(name)+ '&userID=' + this.memberInfo.UserID;
              this.configureInfo.title = '大方租车——共享租车连锁品牌';
              this.configureInfo.content = '送你200元租车大礼包，首租立减100元！'
            }
          }
        },
        async initInviteInfo() {
          let res = await inviteOwnersInfo({
            data:{
              type: this.type
            }
          });
          if (res.Code == 100) {
            this.inviteInfo = res.Data;
          }
        },
        //获取邀请记录
        async inviteMember() {
          let res = await inviteMemberRecords({
            data: {
              type: this.type,
              page: this.pageindex,
              pagesize: 5
            },
            isLoading:true,
            loadContent:'加载中...'
          })
          if (res.Code == 100) {
            for(var i=0;i<res.Data.Rows.length;i++){
              if(res.Data.Rows[i].Status == 1){
                res.Data.Rows[i].StatusText = '注册成功';

              }else{
                this.type == 1 ? res.Data.Rows[i].StatusText = '认证成功' : res.Data.Rows[i].StatusText = '完成订单'
              }
              this.inviteList.push(res.Data.Rows[i]);
            }
            this.total_page = res.Data.Total;
          }
        },
        async inviteBonus(){
          let res = await inviteBonusRecords({
            data: {
              type: this.type,
              page: this.pageindex,
              pagesize: 5
            },
            isLoading:true,
            loadContent:'加载中...'
          })
          if (res.Code == 100) {
            for(var i=0;i<res.Data.Rows.length;i++){
              res.Data.Rows[i].Time = res.Data.Rows[i].Time.slice(0,16).replace('T',' ');
              this.inviteList.push(res.Data.Rows[i]);
            }
            this.total_page = res.Data.Total;
          }
        },
        //切换菜单
        setNav(value) {
          this.curNav = value;
          this.inviteList = [];
          if (this.curNav == 0) {
            this.inviteMember();
          } else {
            this.inviteBonus();
          }
        },
        onPullDownRefresh(){
          this.pageindex = 1;
          this.inviteList = [];
          if(this.curNav == 0){
            this.inviteMember();
          }else{
            this.inviteBonus();
          }
        },
        //上拉加载
        lower() {
          if (this.pageindex < this.total_page) {
            let index = this.pageIndex + 1;
            this.pageIndex = index;
            if(this.curNav == 0){
              this.inviteMember();
            }else{
              this.inviteBonus();
            }
          }
        },
        goIndex(){
          this.$router.replace({ path: '/index' });
        },
        goRule(){
          this.$router.replace({ path: '/rule', query:{type:this.type} });
        },
        openShare(){
          this.showShare = true;
        },
        //关闭分享
        closeShare() {
          this.showShare = false;
        },

        // 复制成功
        onCopy(e){
          this.flexible.showToast({
            content: '复制链接成功，分享给微信好友吧！',
            duration: 2000,
            success: () => {
              this.closeShare();
            }
          });
        },
        shareWechat() {
          //判断是否授权
          if(!sweixin){
            this.flexible.showToast({
              content: "无法分享到微信！",
              duration: 1000
            });
            return
          }
          if(sweixin.authenticated){
            this.doShare();
          }
          else{
            sweixin.authorize(function(){
              this.doShare();
            }, function(e){
              console.log('认证授权失败：'+JSON.stringify(e));
            });
          }

        },
        doShare(){
          let msg = {
            type:"web",
            thumbs:this.configureInfo.thumbs, //图片
            href: this.configureInfo.href,  //地址
            title:this.configureInfo.title,  //标题
            content:this.configureInfo.content, //描述
            extra:{"scene":"WXSceneSession"}
          };
          sweixin.send(msg, function(){
            console.log("分享成功");
          }, function(e){
            console.log("分享失败")
          });
        },

      }
    }
</script>

<style scoped lang="scss" type="text/scss">
.invite{
  position: absolute;
  top: 0px;
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: hidden;
  .bannerInfo{
    color: #fff;
    height: 330px;
    background: url('~@/assets/images/invite/ownerBanner.jpg') no-repeat center center;
    background-size: 100%;
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0px 20px 20px 0;
      box-sizing: border-box;
      height: 110px;
      width: 100%;
      .imageBlock{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 100px;
        .return_ico {
          width: 30px;
          height: 30px;
        }
      }

      .title{
        font-size: 30px;
      }
    }
    .titleBg{
      margin-top: 30px;
      text-align: center;
      font-size: 48px;
    }
  }
  .inviteBlock{
    position: absolute;
    background-color: #fff;
    width: 100%;
    top: 300px;
    bottom: 0px;
    left: 0px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    z-index: 2;
    .rewardCon{
      padding: 60px 20px 0 40px;
      box-sizing: border-box;
      .top{
        display: flex;
        justify-content: space-between;
        padding: 0 100px;
        box-sizing: border-box;
        .item{
          display: flex;
          flex-direction: column;
          text-align: center;
          .value{
            font-size: 46px;
            color:#027FFF;
          }
        }
        .line{
          border-right: 1px solid #9F9F9F;/*no*/
        }
      }
      .inviteBtn{
        padding: 25px 0;
        margin-top: 60px;
        box-sizing: border-box;
        width: 100%;
        text-align: center;
        background: #027FFF;
        border-radius: 6px;
        color: #fff;
      }
    }
    .recordCon{
      margin-top: 60px;
      padding: 0 30px 50px 30px;
      box-sizing: border-box;
      height: 620px;
      border-top: 2px dashed #eeeeee;
      .navs {
        display: flex;
        width: 100%;
        height: 105px;
        background-color: #fff;
        border-bottom: solid 1px #eeeeee; /*no*/
        box-sizing: border-box;
        .navtab {
          flex: 1;
          .nav {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            height: 105px;
            box-sizing: border-box;
            font-size: 28px;
            border-bottom: 6px solid #fff;
            border-top: 6px solid #fff;
            .redDot {
              position: absolute;
              top: 6px;
              right: 6px;
              width: 10px;
              height: 10px;
              border-radius: 5px;
              background: #027FFF;
            }
          }
          .on {
            border-bottom: 6px solid #027FFF;
          }
        }
      }
      .content{
        .list{
          flex: 1;
          width: 100%;
          height: 520px;
          overflow: hidden;
          padding: 0 10px;
          box-sizing: border-box;
          .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 0;
            box-sizing: border-box;
            .left{
              display: flex;
              flex-direction: column;
              color: #9F9F9F;
              font-size: 26px;
              .name{

                color: #000;
              }
            }
            .right{
              color: #FF572C;

            }
            .amount{
              font-size: 32px;
            }
          }
          .nodata{
            display: flex;
            flex-direction: column;
            padding-top: 50px;
            box-sizing: border-box;
            text-align: center;
            color: #9f9f9f;
            img{
              margin: 0 auto;
              width: 160px;
              height: 160px;
            }
            span{
              margin-top: 10px;
            }
          }
          .end{
            padding:30px 0;
            box-sizing: border-box;
            text-align: center;
            border-top: 2px dashed #9f9f9f;
            color: #9F9F9F;
          }
        }

      }
    }

  }
  .share {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.7;
    }
    .content{
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 30px 0;
      box-sizing: border-box;
      width: 100%;
      background: #fff;
      text-align: center;
      .title{
        font-size: 32px;
      }
      .bar {
        padding: 20px 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .item {
          position: relative;
          margin-right: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .ico {
            width: 90px;
            height: 90px;
          }
          .txt {
            margin-top: 15px;
            color: #121212;
            font-size: 24px;
          }
          .btn {
            position: absolute;
            left: 0;
            top: 30px;
            width: 90px;
            height: 140px;
            opacity: 0;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/invite.vue